//# sourceMappingURL=mime_types.mjs.map
/// <reference types="./mime_types.d.mts" />
import * as $decode from "../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../gleam_stdlib/gleam/list.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "./gleam.mjs";

export class Folder extends $CustomType {}
export const MimeType$Folder = () => new Folder();
export const MimeType$isFolder = (value) => value instanceof Folder;

export class Document extends $CustomType {}
export const MimeType$Document = () => new Document();
export const MimeType$isDocument = (value) => value instanceof Document;

export class Docx extends $CustomType {}
export const MimeType$Docx = () => new Docx();
export const MimeType$isDocx = (value) => value instanceof Docx;

export class Dotx extends $CustomType {}
export const MimeType$Dotx = () => new Dotx();
export const MimeType$isDotx = (value) => value instanceof Dotx;

export class Slides extends $CustomType {}
export const MimeType$Slides = () => new Slides();
export const MimeType$isSlides = (value) => value instanceof Slides;

export class Sheet extends $CustomType {}
export const MimeType$Sheet = () => new Sheet();
export const MimeType$isSheet = (value) => value instanceof Sheet;

export class Drawing extends $CustomType {}
export const MimeType$Drawing = () => new Drawing();
export const MimeType$isDrawing = (value) => value instanceof Drawing;

export class Map extends $CustomType {}
export const MimeType$Map = () => new Map();
export const MimeType$isMap = (value) => value instanceof Map;

export class Xlsx extends $CustomType {}
export const MimeType$Xlsx = () => new Xlsx();
export const MimeType$isXlsx = (value) => value instanceof Xlsx;

export class Pptx extends $CustomType {}
export const MimeType$Pptx = () => new Pptx();
export const MimeType$isPptx = (value) => value instanceof Pptx;

export class Mp4 extends $CustomType {}
export const MimeType$Mp4 = () => new Mp4();
export const MimeType$isMp4 = (value) => value instanceof Mp4;

export class Png extends $CustomType {}
export const MimeType$Png = () => new Png();
export const MimeType$isPng = (value) => value instanceof Png;

export class Zip extends $CustomType {}
export const MimeType$Zip = () => new Zip();
export const MimeType$isZip = (value) => value instanceof Zip;

export class Pdf extends $CustomType {}
export const MimeType$Pdf = () => new Pdf();
export const MimeType$isPdf = (value) => value instanceof Pdf;

export class XGzip extends $CustomType {}
export const MimeType$XGzip = () => new XGzip();
export const MimeType$isXGzip = (value) => value instanceof XGzip;

export class XCompressed extends $CustomType {}
export const MimeType$XCompressed = () => new XCompressed();
export const MimeType$isXCompressed = (value) => value instanceof XCompressed;

export class Jpeg extends $CustomType {}
export const MimeType$Jpeg = () => new Jpeg();
export const MimeType$isJpeg = (value) => value instanceof Jpeg;

export class XZipCompressed extends $CustomType {}
export const MimeType$XZipCompressed = () => new XZipCompressed();
export const MimeType$isXZipCompressed = (value) =>
  value instanceof XZipCompressed;

export class Csv extends $CustomType {}
export const MimeType$Csv = () => new Csv();
export const MimeType$isCsv = (value) => value instanceof Csv;

export class Text extends $CustomType {}
export const MimeType$Text = () => new Text();
export const MimeType$isText = (value) => value instanceof Text;

export class Qna extends $CustomType {}
export const MimeType$Qna = () => new Qna();
export const MimeType$isQna = (value) => value instanceof Qna;

export class Markdown extends $CustomType {}
export const MimeType$Markdown = () => new Markdown();
export const MimeType$isMarkdown = (value) => value instanceof Markdown;

export class Proposal extends $CustomType {}
export const MimeType$Proposal = () => new Proposal();
export const MimeType$isProposal = (value) => value instanceof Proposal;

export class Website extends $CustomType {}
export const MimeType$Website = () => new Website();
export const MimeType$isWebsite = (value) => value instanceof Website;

export const uploadable = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Docx(),
  /* @__PURE__ */ new Xlsx(),
  /* @__PURE__ */ new Pdf(),
]);

export function from_string(str) {
  if (str === "application/vnd.google-apps.folder") {
    return new Ok(new Folder());
  } else if (str === "application/vnd.google-apps.document") {
    return new Ok(new Document());
  } else if (
    str === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return new Ok(new Docx());
  } else if (
    str === "application/vnd.openxmlformats-officedocument.wordprocessingml.template"
  ) {
    return new Ok(new Dotx());
  } else if (str === "application/vnd.google-apps.presentation") {
    return new Ok(new Slides());
  } else if (str === "application/vnd.google-apps.spreadsheet") {
    return new Ok(new Sheet());
  } else if (str === "application/vnd.google-apps.drawing") {
    return new Ok(new Drawing());
  } else if (str === "application/vnd.google-apps.map") {
    return new Ok(new Map());
  } else if (
    str === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    return new Ok(new Xlsx());
  } else if (
    str === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ) {
    return new Ok(new Pptx());
  } else if (str === "video/mp4") {
    return new Ok(new Mp4());
  } else if (str === "image/png") {
    return new Ok(new Png());
  } else if (str === "application/zip") {
    return new Ok(new Zip());
  } else if (str === "application/pdf") {
    return new Ok(new Pdf());
  } else if (str === "application/x-gzip") {
    return new Ok(new XGzip());
  } else if (str === "application/x-compressed") {
    return new Ok(new XCompressed());
  } else if (str === "image/jpeg") {
    return new Ok(new Jpeg());
  } else if (str === "application/x-zip-compressed") {
    return new Ok(new XZipCompressed());
  } else if (str === "text/csv") {
    return new Ok(new Csv());
  } else if (str === "text/steerlab-qna") {
    return new Ok(new Qna());
  } else if (str === "text/plain") {
    return new Ok(new Text());
  } else if (str === "text/markdown") {
    return new Ok(new Markdown());
  } else if (str === "text/x-markdown") {
    return new Ok(new Markdown());
  } else if (str === "text/steerlab-proposal") {
    return new Ok(new Proposal());
  } else if (str === "text/html") {
    return new Ok(new Website());
  } else {
    return new Error(undefined);
  }
}

export function to_string(mime_type) {
  if (mime_type instanceof Folder) {
    return "application/vnd.google-apps.folder";
  } else if (mime_type instanceof Document) {
    return "application/vnd.google-apps.document";
  } else if (mime_type instanceof Docx) {
    return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  } else if (mime_type instanceof Dotx) {
    return "application/vnd.openxmlformats-officedocument.wordprocessingml.template";
  } else if (mime_type instanceof Slides) {
    return "application/vnd.google-apps.presentation";
  } else if (mime_type instanceof Sheet) {
    return "application/vnd.google-apps.spreadsheet";
  } else if (mime_type instanceof Drawing) {
    return "application/vnd.google-apps.drawing";
  } else if (mime_type instanceof Map) {
    return "application/vnd.google-apps.map";
  } else if (mime_type instanceof Xlsx) {
    return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  } else if (mime_type instanceof Pptx) {
    return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
  } else if (mime_type instanceof Mp4) {
    return "video/mp4";
  } else if (mime_type instanceof Png) {
    return "image/png";
  } else if (mime_type instanceof Zip) {
    return "application/zip";
  } else if (mime_type instanceof Pdf) {
    return "application/pdf";
  } else if (mime_type instanceof XGzip) {
    return "application/x-gzip";
  } else if (mime_type instanceof XCompressed) {
    return "application/x-compressed";
  } else if (mime_type instanceof Jpeg) {
    return "image/jpeg";
  } else if (mime_type instanceof XZipCompressed) {
    return "application/x-zip-compressed";
  } else if (mime_type instanceof Csv) {
    return "text/csv";
  } else if (mime_type instanceof Text) {
    return "text/plain";
  } else if (mime_type instanceof Qna) {
    return "text/steerlab-qna";
  } else if (mime_type instanceof Markdown) {
    return "text/markdown";
  } else if (mime_type instanceof Proposal) {
    return "text/steerlab-proposal";
  } else {
    return "text/html";
  }
}

export function decoder() {
  return $decode.then$(
    $decode.string,
    (content) => {
      let $ = from_string(content);
      if ($ instanceof Ok) {
        let content$1 = $[0];
        return $decode.success(content$1);
      } else {
        return $decode.failure(new Zip(), "");
      }
    },
  );
}

export function is_processable(mime_type) {
  if (mime_type instanceof Docx) {
    return true;
  } else if (mime_type instanceof Xlsx) {
    return true;
  } else if (mime_type instanceof Pptx) {
    return true;
  } else if (mime_type instanceof Pdf) {
    return true;
  } else if (mime_type instanceof Markdown) {
    return true;
  } else if (mime_type instanceof Proposal) {
    return true;
  } else {
    return false;
  }
}

export function is_uploadable(mime_type) {
  return $list.contains(uploadable, mime_type);
}

export function to_display(mime_type) {
  if (mime_type instanceof Folder) {
    return "Archive";
  } else if (mime_type instanceof Document) {
    return "Google Workspace";
  } else if (mime_type instanceof Docx) {
    return "Word";
  } else if (mime_type instanceof Dotx) {
    return "Word";
  } else if (mime_type instanceof Slides) {
    return "Google Workspace";
  } else if (mime_type instanceof Sheet) {
    return "Google Workspace";
  } else if (mime_type instanceof Drawing) {
    return "Google Workspace";
  } else if (mime_type instanceof Map) {
    return "Google Workspace";
  } else if (mime_type instanceof Xlsx) {
    return "Excel";
  } else if (mime_type instanceof Pptx) {
    return "PowerPoint";
  } else if (mime_type instanceof Mp4) {
    return "Video";
  } else if (mime_type instanceof Png) {
    return "Image";
  } else if (mime_type instanceof Zip) {
    return "Archive";
  } else if (mime_type instanceof Pdf) {
    return "PDF";
  } else if (mime_type instanceof XGzip) {
    return "Archive";
  } else if (mime_type instanceof XCompressed) {
    return "Archive";
  } else if (mime_type instanceof Jpeg) {
    return "Image";
  } else if (mime_type instanceof XZipCompressed) {
    return "Archive";
  } else if (mime_type instanceof Csv) {
    return "CSV";
  } else if (mime_type instanceof Text) {
    return "Text";
  } else if (mime_type instanceof Qna) {
    return "Q&A";
  } else if (mime_type instanceof Markdown) {
    return "Markdown";
  } else if (mime_type instanceof Proposal) {
    return "Proposal";
  } else {
    return "Web Page";
  }
}
